import { useState } from "react";
import { ChildById } from "../ComponentRenderer";
import { ComponentProps } from "../registry";
import { FormSubmitContext, readChildren, useBound } from "../helpers";
import { dispatchAction } from "../../action";
import { ActionDescriptor, BoundValue } from "../../types";

export function Form({ fields, scope }: ComponentProps) {
  const children = readChildren(fields);
  const submit = fields.submitAction as ActionDescriptor | undefined;
  const submitName = useBound<string>(submit?.name as BoundValue | undefined, scope);
  const [submitting, setSubmitting] = useState(false);

  return (
    <form
      className="a2-form"
      onSubmit={async (e) => {
        e.preventDefault();
        if (!submit || submitting) return;
        setSubmitting(true);
        try { await dispatchAction(submit, scope); }
        finally { setSubmitting(false); }
      }}
    >
      <FormSubmitContext.Provider value={typeof submitName === "string" ? submitName : null}>
        {children && "explicitList" in children
          ? children.explicitList.map((id) => <ChildById key={id} id={id} scope={scope} />)
          : null}
      </FormSubmitContext.Provider>
    </form>
  );
}
